import { useCallback, useState } from "react";

/** Give every conversation frame the same send feedback until receipt. */
export function useConversationFramePendingSubmit({
  onSubmit,
}: {
  onSubmit: () => Promise<boolean | void>;
}) {
  const [pending, setPending] = useState(false);
  const submit = useCallback(async () => {
    setPending(true);
    try {
      return await onSubmit();
    } finally {
      setPending(false);
    }
  }, [onSubmit]);
  return { submit, pending };
}
